import * as tslib_1 from "tslib";
import { ContentContainer } from './content_container';
var Popover = /** @class */ (function (_super) {
    tslib_1.__extends(Popover, _super);
    function Popover(param) {
        return _super.call(this, param) || this;
    }
    Popover.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Popover" });
    };
    Popover.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Popover;
}(ContentContainer));
export { Popover };
//# sourceMappingURL=popover.js.map